
export type MarkAllNotificationsAsRead200 = {
  updatedCount: number;
};
